let elem = null;
let base = null;
let childElement = null;

const destroy = () => {
    if (!elem) return;
    removeFocus(elem);
    //base.remove();
    base = null;
    elem = null;
    childElement = null;
};

const init = (newElem) => {
    if (newElem === elem) return true;
    destroy();
    if (!newElem || newElem.classList.contains("disabled") || newElem.classList.contains("no-ripple")) return false;
    elem = newElem;
    base = elem.getElementsByClassName("ripple-base")[0];
    if (base) {
        childElement = base.getElementsByTagName("span")[0];
    } else {
        base = document.createElement("span");
        base.classList.add("ripple-base");
        elem.appendChild(base);

        childElement = document.createElement("span");
        childElement.className = "";
        base.appendChild(childElement);
    }
    return true;
};

const pulse = (element, clientX, clientY) => {
    if (!init(element)) return;
    const container = base;
    var pulseElem = document.createElement("span");
    container.appendChild(pulseElem);
    removeFocus(element);
    let w = container.clientWidth;
    let h = container.clientHeight;
    let radius = Math.max(w, h) / 2;
    let x = clientX ? clientX : 0;
    let y = clientY ? clientY : 0;
    if (x > 0 || y > 0) {
        let rect = element.getBoundingClientRect();
        x -= rect.left;
        y -= rect.top;
        w = Math.max(x, element.clientWidth - x);
        h = Math.max(y, element.clientHeight - y);
        radius = Math.max(w, h);
        x -= radius;
        y -= radius;
    } else {
        radius = Math.sqrt(w * w + h * h);
        x = w / 2 - radius;
        y = h / 2 - radius;
    }

    pulseElem.style.width = `${radius * 2}px`;
    pulseElem.style.height = `${radius * 2}px`;
    pulseElem.style.left = `${x}px`;
    pulseElem.style.top = `${y}px`;
    pulseElem.className = "ripple-pulse";

    setTimeout(() => pulseElem.remove(), 600);
};

const focus = (element) => {
    if (!init(element)) return;
    const container = base;
    if (elem.getElementsByClassName("ripple-pulse")[0]) return;
    if (childElement.className === "ripple-focus") return;
    var w = container.clientWidth;
    var h = container.clientHeight;
    if (w < 10 || h < 10) return;
    var sizePercent = Math.max(0.85, w < h ? w / h : h / w);
    var rippleSize = (Math.max(w, h) / 2) * sizePercent;
    if (w / 2 - rippleSize > 10) rippleSize = w / 2 - 5;
    else if (h / 2 - rippleSize > 10) rippleSize = h / 2 - 5;
    var x = w / 2;
    var y = h / 2;
    setChildElement("ripple-focus", x, y, rippleSize);
};

function setChildElement(className, x, y, radius) {
    childElement.style.width = `${radius * 2}px`;
    childElement.style.height = `${radius * 2}px`;
    childElement.style.left = `${x - radius}px`;
    childElement.style.top = `${y - radius}px`;
    childElement.style.animation = "";
    childElement.className = className;
}

const blur = (element) => {
    removeFocus(element);
    if (!element || element !== elem) return;
    //destroy();
};

const removeFocus = (element) => {
    if (!element) return;
    var focus = element.getElementsByClassName("ripple-focus")[0];
    if (focus) {
        focus.style.animation = "none";
        setTimeout(function () {
            focus.className = "";
        });
    }
};

function getOffset(elem) {
    if (!elem) return { top: 0, left: 0 };
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;
    var p = { top: Math.round(top), left: Math.round(left) };
    return p;
}

export const ripple = { init, pulse, focus, blur, removeFocus };
